<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/login-bg.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

h3{
  text-align: center;
  font-size: 25px;
}

.label{
  margin: 10px 10px 1px 10px;
}

.link{
  padding: 20px 0;
  margin: 30px 0;
  text-align: center;
  color: blue;
  text-decoration: underline;
  font-size: 16px;
}
.link:hover{
  color: black;
}

button{
  color: black;
  border: 4px black solid;
  box-shadow: 0 5px 5px gray;
  background-color: rgba(255,255,255,0.5);
}
button:hover{
  color: white;
  background-color: black;
}

.margin{
  height: 100px;
}

</style>


<div class="bg">
  
  <h3>Log In</h3>
  
  <div class="label">Email / Phone</div>
  <div><input type="text" bind:value="{user}"></div>
  
  <div class="label">Password</div>
  <div><input type="password" bind:value="{password}"></div>
  
  <div class="margin"></div>
  
  <button on:click="{ () => push('/events') }">Log In</button>
  
  <div class="link" on:click="{ () => push('/signup/profile/type') }">Don't have an account?</div>
  
</div>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';

let user = "alij83@example.com";
let password = "Alison James";

</script>